import { render, staticRenderFns } from "./breach-exposure.vue?vue&type=template&id=5f9064e4&scoped=true"
import script from "./breach-exposure.vue?vue&type=script&lang=js"
export * from "./breach-exposure.vue?vue&type=script&lang=js"
import style0 from "./breach-exposure.vue?vue&type=style&index=0&id=5f9064e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9064e4",
  null
  
)

export default component.exports